import { create } from "zustand";

export interface Toast {
  show: boolean;
  status: "success" | "error" | "warning" | "info";
  title: string;
}

interface ToastState {
  toast: Toast;
  setToast: (toast: Toast) => void;
}

const PENDING_TOAST_KEY = "pendingToast";

/**
 * For a toast that has to outlive a full page load in this tab, such as the reason for a
 * sign-out: logout() hard-navigates to /login, which drops anything passed to setToast. The next
 * load shows it once.
 */
export const setToastAfterReload = (toast: Toast) => {
  try {
    sessionStorage.setItem(PENDING_TOAST_KEY, JSON.stringify(toast));
  } catch {
    // Storage can be unavailable (private mode, blocked site data); the sign-out still happens.
  }
};

const takePendingToast = (): Toast | null => {
  try {
    const pending = sessionStorage.getItem(PENDING_TOAST_KEY);
    sessionStorage.removeItem(PENDING_TOAST_KEY);
    return pending ? JSON.parse(pending) : null;
  } catch {
    return null;
  }
};

export const useToastStore = create<ToastState>((set) => ({
  toast: takePendingToast() ?? { show: false, status: "success", title: "" },
  setToast: (toast: Toast) => set(() => ({ toast })),
}));
